import React from 'react'
import { Link } from 'react-router'
import { Container } from 'react-grid-system'
import { translate } from 'react-i18next'

// STYLES
import styled, { keyframes } from 'styled-components'
import { fadeIn } from 'react-animations'

// COMPONENTS
import Footer from '../../sections/footer/footer.section'

// IMAGES
import Logo from '../../assets/images/logo-quality-small.svg'

// ICONS
import MdMenu from 'react-icons/lib/md/menu'

import Scroll from 'react-scroll-to-element'

import Scrollspy from 'react-scrollspy'

class Header extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selected: 0,
      isOpen: false,
      page: true
    }
    window.__forceSmoothScrollPolyfill__ = true
  }

	changeLanguage = (lng) => {
	  this.props.i18n.changeLanguage(lng)
	}

	openMenu = () => {
	  const { isOpen } = this.state
	  this.setState({ isOpen: !isOpen })
	}

	render () {
	  const { t, i18n } = this.props
	  const { isOpen } = this.state
	  return (
  <Master>
  <HeaderContent>
  <Container>
  <HeaderItems>
  <HeaderLogo>
  <Scroll type='id' element='banner'>
  <Link>
  <img src={Logo} alt='Logo' />
	                </Link>
	              </Scroll>
	            </HeaderLogo>
  <HeaderMenu>
  <Scrollspy items={['banner', 'recipients', 'advantages', 'qualification', 'studies', 'practices', 'platform', 'more']} currentClassName='activeMenu' offset={-90}>
  <Scroll type='id' element='banner'>
  <MenuItem>
  {t('Programa Quality')}
	                  </MenuItem>
	                </Scroll>
  <Scroll type='id' element='recipients' offset={-60}>
  <MenuItem>
  {t('Destinatários')}
	                  </MenuItem>
	                </Scroll>
  <Scroll type='id' element='advantages' offset={-60}>
  <MenuItem>
  {t('Vantagens')}
	                  </MenuItem>
	                </Scroll>
  <Scroll type='id' element='qualification' offset={-60}>
  <MenuItem>
  {t('Eventos')}
	                  </MenuItem>
	                </Scroll>
  <Scroll type='id' element='studies' offset={-60}>
  <MenuItem>
  {t('Estudos')}
	                  </MenuItem>
	                </Scroll>
  <Scroll type='id' element='practices' offset={-60}>
  <MenuItem>
  {t('Boas Práticas')}
	                  </MenuItem>
	                </Scroll>
  <Scroll type='id' element='platform' offset={-60}>
  <MenuItem>
  {t('Promoção')}
	                  </MenuItem>
	                </Scroll>
	              </Scrollspy>
	            </HeaderMenu>
  <HeaderButtons>
  <HeaderLanguage>
  <HeaderLanguageItem className={i18n.language === 'pt' ? 'activeLanguage' : ''} onClick={() => this.changeLanguage('pt')}>
										PT
	                </HeaderLanguageItem>
									/
  <HeaderLanguageItem className={i18n.language === 'en' ? 'activeLanguage' : ''} onClick={() => this.changeLanguage('en')}>
										EN
	                </HeaderLanguageItem>
	              </HeaderLanguage>
  <Buttons>
  <Link href={`${process.env.REACT_APP_QUALITY_API}/area-reservada/`}>
  <BtnArea>
  {t('Área Reservada')}
	                  </BtnArea>
	                </Link>
  <Scroll type='id' element='more' offset={-10}>
  <BtnMore>
  {t('Registo')}
	                  </BtnMore>
	                </Scroll>
	              </Buttons>
  <ButtonResponsive onClick={this.openMenu} className={isOpen ? 'activeResponsive' : ''}>
  <MdMenu />
	              </ButtonResponsive>
	            </HeaderButtons>
	          </HeaderItems>
	        </Container>
	      </HeaderContent>
  {
	        isOpen &&
					<ResponsiveMenu>
  <Scrollspy items={['banner', 'recipients', 'advantages', 'qualification', 'studies', 'practices', 'platform']} currentClassName='activeMenuResponsive' offset={-90}>
  <ResponsiveMenuItem onClick={this.openMenu}>
  <Scroll type='id' element='banner'>
  {t('Programa Quality')}
					      </Scroll>
					    </ResponsiveMenuItem>
  <ResponsiveMenuItem onClick={this.openMenu}>
  <Scroll type='id' element='recipients' offset={-60}>
  {t('Destinatários')}
					      </Scroll>
					    </ResponsiveMenuItem>
  <ResponsiveMenuItem onClick={this.openMenu}>
  <Scroll type='id' element='advantages' offset={-60}>
  {t('Vantagens')}
					      </Scroll>
					    </ResponsiveMenuItem>
  <ResponsiveMenuItem onClick={this.openMenu}>
  <Scroll type='id' element='qualification' offset={-60}>
  {t('Eventos')}
					      </Scroll>
					    </ResponsiveMenuItem>
  <ResponsiveMenuItem onClick={this.openMenu}>
  <Scroll type='id' element='studies' offset={-60}>
  {t('Estudos')}
					      </Scroll>
					    </ResponsiveMenuItem>
  <ResponsiveMenuItem onClick={this.openMenu}>
  <Scroll type='id' element='practices' offset={-60}>
  {t('Boas Práticas')}
					      </Scroll>
					    </ResponsiveMenuItem>
  <ResponsiveMenuItem onClick={this.openMenu}>
  <Scroll type='id' element='platform' offset={-60}>
  {t('Promoção')}
					      </Scroll>
					    </ResponsiveMenuItem>
  <ResponsiveMenuItem>
  <Link href={`${process.env.REACT_APP_QUALITY_API}/area-reservada/`}>
  <ResponsiveBtnArea>
  {t('Área Reservada')}
					        </ResponsiveBtnArea>
					      </Link>
  <div onClick={this.openMenu}>
  <Scroll type='id' element='more' offset={-60}>
  <ResponsiveBtnMore>
  {t('Registo')}
					          </ResponsiveBtnMore>
					        </Scroll>
					      </div>
					    </ResponsiveMenuItem>
					  </Scrollspy>
					</ResponsiveMenu>
	      }

  {this.props.children}
  <Footer t={t} />
	    </Master>
	  )
	}
}

export default translate('translations')(Header)

const Master = styled.div`
`
const HeaderContent = styled.div`
    width: 100%;
    height: 80px;
    background-color: #FFF;
    box-shadow: inset 0 -1px 0 0 #DDDDDD;
    position: fixed;
    top: 0;
    z-index: 1000;
`
const HeaderItems = styled.div`
    display: flex;
    align-items: center;
    height: 80px;
`
const HeaderLogo = styled.div`
    @media screen and (max-width: 1200px) {
        flex: 2;
    }
`
const HeaderMenu = styled.div`
    ul {
        flex:2;
        display: flex;
        align-items: center;
        height: 80px;
    }

    @media screen and (max-width: 1200px) {
        display: none;
    }
`
const MenuItem = styled.a`
    color: rgba(4, 24, 37, 0.6);
    font-family: Dosis;
    font-size: 15px;
    font-weight: 500;
    margin-left: 15px;
    cursor: pointer;
    height: 100%;
    line-height: 80px;
    transition: all 0.2s ease;

    &:hover{
        box-shadow: inset 0 -3px 0 0 #2E84C6;
        color: rgba(4, 24, 37, 1)
    }

    a{
        color: rgba(4, 24, 37, 0.6);
        font-family: Dosis;
        font-size: 15px;
        font-weight: 500;
        cursor: pointer;
        height: 100%;
        line-height: 80px;
        transition: all 0.2s ease;
        text-decoration: none;
    }
`
const HeaderButtons = styled.div`
    display: flex;
`
const HeaderLanguage = styled.div`
    display: flex;
    align-items: center;
    color: rgba(4, 24, 37, 0.6);
    font-family: Dosis;
    font-size: 15px;
    font-weight: 500;
    margin-left: 15px;
    cursor: pointer;
`
const HeaderLanguageItem = styled.div`
    transition: all 0.2s ease;

    &:hover{
        color: #2E84C6;
        font-weight: 600;
    }
`
const Buttons = styled.div`
    display: flex;
    align-items: center;
    a{
        text-decoration: none;
    }

    @media screen and (max-width: 767px) {
        display: none;
    }

`
const BtnArea = styled.div`
    width: 120px;
    height: 32px;
    border: 1px solid #2E84C6;
    border-radius: 4px;
    background-color: #FFFFFF;
    font-size: 12px;
    transition: all 0.2s ease;
    cursor: pointer;
    color: #2E84C6;
    font-weight: bold;
    line-height: 32px;
    margin-right: 10px;
    margin-left: 15px;
    text-align: center;
    text-decoration: none!important;
`
const BtnMore = styled.div`
    min-width: 120px;
    height: 34px;
    border-radius: 4px;
    background-color: #2E84C6;
    font-size: 12px;
    transition: all 0.2s ease;
    cursor: pointer;
    color: #FFF;
    font-weight: bold;
    line-height: 34px;
    text-align: center;
    padding-left: 10px;
    padding-right: 10px;

    a{
        color: #FFF;
    }
`
const ButtonResponsive = styled.div`
    width: 50px;
    height: 50px;
    font-size: 33px;
    text-align: center;
    line-height: 46px;
    color: rgba(4, 24, 37, 0.6);
    margin-left: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: none;

    &:hover{
        color: #2E84C6;
    }

    @media screen and (max-width: 1200px) {
        display: block;
    }
`
const fadeInAnimation = keyframes`${fadeIn}`

const ResponsiveMenu = styled.div`
    ul{
        width: calc(100% - 30px);
        position: fixed;
        top: 60px;
        bottom: 0px;
        background-color: #FFF;
        z-index: 11;
        overflow-y: auto;
        text-align: center;
        padding-left: 15px;
        padding-right: 15px;
        padding-bottom: 15px;
        padding-top: 40px;
        animation: 0.5s ${fadeInAnimation};
    }
`
const ResponsiveMenuItem = styled.div`
    color: rgba(4, 24, 37, 0.6);
    font-family: Dosis;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    padding-top: 15px;
    padding-bottom: 15px;

    a{
        text-decoration: none;
        color: rgba(4, 24, 37, 0.6);
    }

    a:hover{
        color: rgba(4, 24, 37, 1);
    }

    &:hover{
        color: rgba(4, 24, 37, 1);
    }
`
const ResponsiveBtnArea = styled.div`
    max-width: 180px;
    height: 32px;
    border: 1px solid #2E84C6;
    border-radius: 4px;
    background-color: #FFFFFF;
    font-size: 12px;
    transition: all 0.2s ease;
    cursor: pointer;
    color: #2E84C6;
    font-weight: bold;
    line-height: 32px;
    text-align: center;
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
`
const ResponsiveBtnMore = styled.div`
		max-width: 180px;
    border-radius: 4px;
    background-color: #2E84C6;
    font-size: 12px;
    transition: all 0.2s ease;
    cursor: pointer;
    color: #FFF;
    font-weight: bold;
    line-height: 34px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;

    a{
        color: #FFF;
    }
    a:hover{
        color: #FFF;
    }
`



// WEBPACK FOOTER //
// ./src/components/header/header.component.js